import { camelCase } from 'lodash';

import { Vehicle } from './vehicle.model';

export class User {
  usrUserId: number = null;
  usrUsername: string = null;
  usrPassword: string = null;
  usrCustomerId: number = null;
  usrAccessLevel: number = null;
  usrLastLogon: Date = null;
  usrLogonCount: number = null;
  usrStartAccess: number = null;
  usrEndAccess: number = null;
  usrWeekends: string = null;
  usrCostCentreId: number = null;
  usrB2C: string = null;
  usrEmail: string = null;
  usrFcAdmin: boolean = null;
  premium: {
    isPremiumMember: boolean;
    smsSubscriptionQuantity: number;
  } = null;
  renewalPending: Vehicle[] = null;

  constructor(obj?: any) {
    for (const field in obj) {
      const camelCasedField = camelCase(field);
      if (typeof this[camelCasedField] !== 'undefined') {
        this[camelCasedField] = obj && obj[field];
      }
    }
  }
}
